import type { ReactNode } from 'react';

/**
 * A label that always occupies the width of its widest face (#1070).
 *
 * Every face is stacked in the same grid cell; the inactive ones are
 * `invisible` and `aria-hidden`, so they reserve width without being seen or
 * read. A toggle whose text changes (e.g. "1-Click" → "1-CLICK ARMED") keeps
 * one size, and nothing beside it slides when it flips.
 */
export function StableWidthLabel({ faces, active }: { faces: ReactNode[]; active: number }) {
  return (
    <span className="inline-grid">
      {faces.map((face, i) => (
        <span
          key={i}
          aria-hidden={i === active ? undefined : true}
          className={
            'col-start-1 row-start-1 inline-flex items-center justify-center gap-1.5' +
            (i === active ? '' : ' invisible')
          }
        >
          {face}
        </span>
      ))}
    </span>
  );
}
